import { forwardRef } from 'react';

import PropTypes from 'prop-types';

import MDButtonRoot from 'components/MDButton/MDButtonRoot';

import { useMaterialUIController } from 'context';

const MDButton = forwardRef(
  (
    {
      color = 'white',
      variant = 'contained',
      size = 'medium',
      circular = false,
      iconOnly = false,
      children,
      loading,
      ...rest
    },
    ref
  ) => {
    const { controller } = useMaterialUIController();
    const { darkMode } = controller;

    return (
      <MDButtonRoot
        {...rest}
        ref={ref}
        color="primary"
        variant={variant === 'gradient' ? 'contained' : variant}
        size={size}
        loading={loading}
        ownerState={{ color, variant, size, circular, iconOnly, darkMode, loading }}
      >
        {children}
      </MDButtonRoot>
    );
  }
);

// Typechecking props for the MDButton
MDButton.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  variant: PropTypes.oneOf(['text', 'contained', 'outlined', 'gradient']),
  color: PropTypes.oneOf([
    'white',
    'primary',
    'secondary',
    'info',
    'infoBlue',
    'tools',
    'success',
    'warning',
    'error',
    'light',
    'dark'
  ]),
  circular: PropTypes.bool,
  iconOnly: PropTypes.bool,
  loading: PropTypes.bool,
  children: PropTypes.node.isRequired
};

export default MDButton;
